import React, { useEffect, useState } from 'react';
import { formatCalData } from '../../utilities/courseFormat';
import { getCalendarAdmin } from '../../services/unitOfferService';
import { getCourses } from '../../services/courseService';
import CourseCalendar from '../CourseCalendar';

const DEFAULT_PAGE_SIZE = 0;
const DEFAULT_PAGE_NO = 0;

const CourseOfferCalendarView = () => {
  const [calData, setCalData] = useState({});
  const [courses, setCourses] = useState([]);

  const fetchCalendarData = (month, year) => {
    getCalendarAdmin(DEFAULT_PAGE_NO, DEFAULT_PAGE_SIZE, {
      month: month,
      year: year,
      collection: 'courseOffer',
      timezoneId: Intl.DateTimeFormat().resolvedOptions().timeZone,
    })
      .then((res) => {
        const formattedCalData = formatCalData(res.data);
        setCalData(formattedCalData);
      })
      .catch();
  };

  const fetchCourses = () => {
    getCourses()
      .then((response) => {
        const courseList = response.data.paginatedList;
        const data = courseList.map((course) => ({
          value: course.code,
          label: course.description,
        }));
        setCourses(data);
      })
      .catch((error) => {
        console.log('Error getting courses from the admin backend:', error);
      });
  };

  const handleCalChange = (moment_dt) => {
    const [month, year] = [moment_dt.month(), moment_dt.year()];
    fetchCalendarData(month + 1, year);
  };

  useEffect(() => {
    fetchCourses();
    const today = new Date();
    const [month, year] = [today.getMonth(), today.getFullYear()];
    fetchCalendarData(month + 1, year);
  }, []);

  return (
    <div>
      <CourseCalendar
        title="Course Offers"
        calData={calData}
        onCalChange={handleCalChange}
        courses={courses}
        forAdmin={true}
      />
    </div>
  );
};

export default CourseOfferCalendarView;
